/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1711
 */

"use strict"

var r = require(/* 86 */"./1650/86/index")
var /* [auto-meaningful-name] */require_959_$_1785_959$codeAt = require(/* 959 */"./1785/959").codeAt
r({
  target: "String",
  proto: true
}, {
  codePointAt: function (e) {
    return require_959_$_1785_959$codeAt(this, e)
  }
})
